import { render, staticRenderFns } from "./TaskCalendar.vue?vue&type=template&id=90af6eb4"
import script from "./TaskCalendar.vue?vue&type=script&lang=js"
export * from "./TaskCalendar.vue?vue&type=script&lang=js"
import style0 from "./TaskCalendar.vue?vue&type=style&index=0&id=90af6eb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports